import { gql } from "@apollo/client";

export const UPDATE_INVOICE_ISSUER = gql`
  mutation updateInvoiceIssuer($input: UpdateInvoiceIssuerInput!) {
    invoice {
      updateInvoiceIssuer(input: $input) {
        success
      }
    }
  }
`;
